import TabTemplate from "components/shared/profile/tab";
import React from "react";
import { updateDriverEducationResourceSettings } from "sources/profile/organization";
import Form from "./form";

export default class EducationResourcesTab extends TabTemplate {
    componentDidMount() {
        this.props.getDriverEducationResourceSettings().then(() => this.setState({ isLoading: false }));
    }

    renderBody = () => {
        const { editable, educationResources, getDriverEducationResourceSettings } = this.props;
        return (
            <Form
                action={updateDriverEducationResourceSettings}
                data={educationResources}
                update={getDriverEducationResourceSettings}
                editable={editable}
                shouldUpdate={this.state.shouldUpdate}
                updateToggle={this.updateToggle}
            />
        );
    };
}
